import * as propertyTypes from "../../property_types.js"

export class DataIsTemplateStringProperty extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;
    private dataMetadata = new propertyTypes.TemplateProperty("data", "Data");

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.allMetadata = [this.nameMetadata, this.dataMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

export class RightDrawerContainer extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;
    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", RightDrawerContainerData);

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.allMetadata = [this.nameMetadata, this.dataMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class RightDrawerContainerData extends propertyTypes.Serializable {

    private visibleMetadata = new propertyTypes.TextCheckboxProperty("visible", "Visible");
    public visible: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private drawerStyleMetadata = new propertyTypes.TextProperty("drawerStyle", "DrawerStyle");
    public drawerStyle: string;

    private multipleComponentsMetadata = new propertyTypes.ObjectListPropertyExt("multipleComponents", "Multiple components", "moduleName")
        .addStateImplementation("app/core/components/quickInfo", MultipleComponentsQuickInfo)
        .addStateImplementation("app/core/components/iframe", Iframe)
        .addStateImplementation("app/core/components/baseDataTreeStructure", BaseDataTreeStructure)
        .addStateImplementation("app/core/components/gmEmbedApi", EmbeddedMaps)
        .addStateImplementation("app/core/components/formGeneratorSearchField", FormGeneratorSearchField);


    public multipleComponents: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.visibleMetadata, this.widthMetadata, this.drawerStyleMetadata, this.multipleComponentsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class MultipleComponentsQuickInfo extends propertyTypes.Serializable {

    private iconNameMetadata = new propertyTypes.FontawesomeIconProperty("iconName", "Icon name");
    public iconName: string;

    private propsMetadata = new propertyTypes.ObjectPropertyExt("props", "Props")
        .addStateImplementation("default", QuickInfoProps);
    public props: string;

    private showMetadata = new propertyTypes.TemplateProperty("show", "Show");
    public show: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.propsMetadata.RenderInline = true;
        this.allMetadata = [this.iconNameMetadata, this.showMetadata, this.propsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class QuickInfoProps extends propertyTypes.Serializable {

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private moduleNameMetadata = new propertyTypes.ObjectPropertyExt("dynamicApi", "Dynamic api")
        .addStateImplementation("default", DynamicApi);

    private statisticsMetadata = new propertyTypes.ObjectListPropertyExt("statistics", "Statistics")
        .addStateImplementation("default", RightDrawerStatistic);

    public statistics: RightDrawerStatistic[];
    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.templateMetadata, this.moduleNameMetadata, this.statisticsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class DynamicApi extends propertyTypes.Serializable {

    private templateMetadata = new propertyTypes.ServiceSelectorProperty("url", "Url", false, propertyTypes.DataSourceType.sql);
    public template: string;

    private parametersMetadata = new propertyTypes.DictionaryProperty("parameters", "Parameters");
    public parameters: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.templateMetadata, this.parametersMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

export class DataMenu extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectListPropertyExt("data", "Data")
        .addStateImplementation("default", MenuItem);
    public data: MenuItem[];

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class MenuItem extends propertyTypes.Serializable {
    private textMetadata = new propertyTypes.TranslatableTextProperty("text", "Text");
    public text: string;

    private onClickMetadata = new propertyTypes.TemplateProperty("onClick", "On click");
    public onClick: string;

    private showMetadata = new propertyTypes.TemplateProperty("show", "Show");
    public show: string;

    private typeMetadata = new propertyTypes.TextProperty("type", "Type");
    public type: string;

    private inContextMetadata = new propertyTypes.CheckBoxProperty("inContext", "In context");
    public inContext: string;

    private iconNameMetadata = new propertyTypes.FontawesomeIconProperty("icon", "Icon");
    public iconName: string;

    private floatingMetadata = new propertyTypes.CheckBoxProperty("floating", "Floating");
    public floating: string;

    private floatingColorMetadata = new propertyTypes.TextCheckboxProperty("floatingColor", "Floating color");
    public floatingColor: string;

    private dataMetadata = new propertyTypes.NotEditableProperty("data", "Data");
    public data: string;

    private reevaluateMetadata = new propertyTypes.NotEditableProperty("reevaluate", "Reevaluate");
    public reevaluate: string[];

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata = [this.textMetadata, this.onClickMetadata, this.showMetadata, this.typeMetadata, this.inContextMetadata,
        this.iconNameMetadata, this.dataMetadata, this.floatingMetadata, this.floatingColorMetadata, this.reevaluateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class RightDrawerStatistic extends propertyTypes.Serializable {
    private titleMetadata = new propertyTypes.TranslatableTextProperty("title", "Title");
    public title: string;

    private statisticIdMetadata = new propertyTypes.StatisticProperty("statisticId", "Statistic id");
    public statisticId: string;

    private parametersMetadata = new propertyTypes.DictionaryProperty("parameters", "Parameters");
    public parameters: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.titleMetadata, this.statisticIdMetadata, this.parametersMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

export class DataGridOptions extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", GridOptions);
    public data: GridOptions;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class GridOptions extends propertyTypes.Serializable {
    private sortableMetadata = new propertyTypes.CheckBoxProperty("sortable", "Sortable");
    public sortable: string;

    private pageableMetadata = new propertyTypes.CheckBoxProperty("pageable", "Pageable");
    public pageable: string;

    private groupableMetadata = new propertyTypes.CheckBoxProperty("groupable", "Groupable");
    public groupable: string;

    private filterableMetadata = new propertyTypes.CheckBoxProperty("filterable", "Filterable");
    public filterable: string;

    private selectableMetadata = new propertyTypes.CheckBoxProperty("selectable", "Selectable");
    public selectable: string;

    private resizableMetadata = new propertyTypes.CheckBoxProperty("resizable", "Resizable");
    public resizable: string;

    private scrollableMetadata = new propertyTypes.CheckBoxProperty("scrollable", "Scrollable");
    public scrollable: string;

    private editableMetadata = new propertyTypes.CheckBoxProperty("editable", "Editable");
    public editable: string;

    private contextMetadata = new propertyTypes.CheckBoxProperty("context", "context");
    public context: string;

    private columnsMetadata = new propertyTypes.ObjectListPropertyExt("columns", "Columns")
        .addStateImplementation("default", Column);
    public columns: Column[];

    private schemaMetadata = new propertyTypes.NotEditableProperty("schema", "Schema");
    public schema: any;

    private valueAxisMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.valueAxisMetadata = [this.sortableMetadata, this.pageableMetadata, this.groupableMetadata, this.filterableMetadata,
        this.selectableMetadata, this.resizableMetadata, this.scrollableMetadata, this.editableMetadata, this.contextMetadata, this.columnsMetadata,
        this.schemaMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.valueAxisMetadata;
    }
}

class Column extends propertyTypes.Serializable {
    private fieldMetadata = new propertyTypes.TextProperty("field", "Field");
    public field: string;

    private titleMetadata = new propertyTypes.TranslatableTextProperty("title", "Title");
    public title: string;

    private widthMetadata = new propertyTypes.TextProperty("width", "Width");
    public width: string;

    private templateMetadata = new propertyTypes.TextProperty("template", "Template");
    public template: string;

    private formatMetadata = new propertyTypes.TextProperty("format", "Format");
    public format: string;

    private hiddenMetadata = new propertyTypes.TextProperty("hidden", "Hidden");
    public hidden: string;

    private valueAxisMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.valueAxisMetadata = [this.fieldMetadata, this.titleMetadata, this.widthMetadata, this.templateMetadata, this.formatMetadata, this.hiddenMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.valueAxisMetadata;
    }
}

class Iframe extends propertyTypes.Serializable {

    private iconNameMetadata = new propertyTypes.FontawesomeIconProperty("iconName", "Icon name");
    public iconName: string;

    private renderAlwaysMetadata = new propertyTypes.CheckBoxProperty("renderAlways", "Render always");
    public renderAlways: object;

    private propsMetadata = new propertyTypes.ObjectPropertyExt("props", "Props")
        .addStateImplementation("default", IframeProps);
    public prop: object;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.iconNameMetadata, this.renderAlwaysMetadata, this.propsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class IframeProps extends propertyTypes.Serializable {
    private urlMetadata = new propertyTypes.TemplateProperty("url", "Url");
    public url: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        //this.urlMetadata.IsReadOnly = true;
        this.allMetadata = [this.urlMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class EmbeddedMaps extends propertyTypes.Serializable {
    private iconNameMetadata = new propertyTypes.TemplateProperty("iconName", "Icon name");
    public iconName: string;

    private propsMetadata = new propertyTypes.ObjectPropertyExt("props", "Props")
        .addStateImplementation("default", EmbeddedMapsProps);

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.iconNameMetadata, this.propsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class FormGeneratorSearchField extends propertyTypes.Serializable {
    private iconNameMetadata = new propertyTypes.FontawesomeIconProperty("iconName", "Icon name");
    public iconName: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.iconNameMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class EmbeddedMapsProps extends propertyTypes.Serializable {
    private latitudeMetadata = new propertyTypes.TextProperty("latitude", "Latitude");
    public latitude: string;
    private longitudeMetadata = new propertyTypes.TextProperty("longitude", "Latitude");
    public longitude: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.latitudeMetadata, this.longitudeMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class BaseDataTreeStructure extends propertyTypes.Serializable {
    private iconNameMetadata = new propertyTypes.TemplateProperty("iconName", "Icon name");
    public iconName: string;

    private propsMetadata = new propertyTypes.ObjectPropertyExt("props", "Props")
        .addStateImplementation("default", BaseDataTreeStructureProps);

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.iconNameMetadata, this.propsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}

class BaseDataTreeStructureProps extends propertyTypes.Serializable {
    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private allMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allMetadata = [this.templateMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allMetadata;
    }
}